import { clamp, isEmpty } from 'lodash';

const OPTIMAL_CATCH_HEIGHT = 1.5; // YDS (or 4.5 feet) i.e. approx center chest
const OPTIMAL_CATCH_DELTAX = 0; // Yds, i.e. dead center
const PASS_AIR_YARDS_SCALE_MAX = 30; // yds

const proximityValue = function (passNode) {
  const dx = passNode.passPlacementX - OPTIMAL_CATCH_DELTAX;
  const dy = passNode.passPlacementY - OPTIMAL_CATCH_HEIGHT;
  return 1 - clamp(Math.hypot(dx, dy), 0, 2) / 2;
};

const passLengthValue = function (passNode) {
  const fractionOfScale =
    clamp(passNode.passAirYards, 0, PASS_AIR_YARDS_SCALE_MAX) /
    PASS_AIR_YARDS_SCALE_MAX;
  return fractionOfScale;
};

/**
 * Partition pass placement data into focus and background sets
 * @param {Object} data - The pass placement data with passEvents.edges structure
 * @param {Array} selectedPlayIds - Array of selected play IDs
 * @returns {Object} - Object with focusData and backgroundData
 */
export const partitionPassPlacementData = (data, selectedPlayIds) => {
  if (isEmpty(data) || !data.passEvents?.edges) {
    return {
      focusData: { passEvents: { edges: [] } },
      backgroundData: { passEvents: { edges: [] } },
    };
  }

  const allEdges = data.passEvents.edges;

  // If no selection, all data is in focus
  if (isEmpty(selectedPlayIds)) {
    return {
      focusData: data,
      backgroundData: { passEvents: { edges: [] } },
    };
  }

  const focusEdges = allEdges.filter((edge) =>
    selectedPlayIds.includes(edge.node.play?.id),
  );

  const backgroundEdges = allEdges.filter(
    (edge) => !selectedPlayIds.includes(edge.node.play?.id),
  );

  return {
    focusData: { passEvents: { edges: focusEdges } },
    backgroundData: { passEvents: { edges: backgroundEdges } },
  };
};

export { proximityValue, passLengthValue };
